import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
// import Heading from "../Heading";

//
import NotificationActions from "../../../store/actions/NotificationActions";

const NotificationItem = ({ notification }) => {
  const dispatch = useDispatch();

  let colorClasses = "";
  switch (notification.type) {
    case "error":
      colorClasses = "error"; // these classes will be applied if notification is about error
      break;
    case "success":
      colorClasses = "success"; // these classes will be applied if notification is about success
      break;
    case "warning":
      colorClasses = "warning"; // these classes will be applied if notification is about warning
      break;
  }

  useEffect(() => {
    setTimeout(() => {
      dispatch(NotificationActions.remoevNotification(notification.id));
    }, 6500);
  }, []);

  return (
    <div className={`${colorClasses} notification`}>
      {notification.text && <p>{notification.text}</p>}
      {notification.linkText && notification.linkURL && (
        <a href={notification.linkURL} target="_blank">
          {notification.linkText}
        </a>
      )}
    </div>
  );
};

export default NotificationItem;
